import _ from 'lodash';

const defaultInventory = (state)=>{
  return _.find(state.inventories, inv=>{return inv.default==true});
}

const getInventory = (state) => (inventoryId) =>{
  if(inventoryId==null)return "";
  return _.find(state.inventories, inv=>{return inv.id === inventoryId});
}

const isMultipleInventorySystem = (state) => {
  let count = 0;
  _.forEach(state.inventories, (i) => {
    if (i.code !== 'IP' && i.code !== 'SAQ'){
      count++;
    }
  })
  return count > 0;
}

const getWinePrivateImportInventories = (state) => {
  return _.filter(state.inventories, inv => inv.code === 'IP' || inv.code === 'PI');
}

const getInventoriesForReporting = (state) => {
  return _.filter(state.inventories, inv => inv.code != 'SAMPLE');
}

export default {
  defaultInventory,
  getInventory,
  isMultipleInventorySystem,
  getWinePrivateImportInventories,
  getInventoriesForReporting,
};
